import { useState, useEffect } from 'react';
import { getUserPermission, IUserPermission } from '@/api/user';
import { PromiseState } from '@/constants';

const usePermission = () => {
  const [permission, setPermission] = useState<IUserPermission>({status: PromiseState.PENDING});

  useEffect(() => {
    getUserPermission().then(() => {
      setPermission({ ...permission, code: undefined, message: undefined, status: PromiseState.FULFILLED });
    }).catch((e) => {
      setPermission({ ...permission, code: e?.code, message: e?.message, status: PromiseState.REJECTED });
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return permission;
};

export default usePermission;
